<script>
    import { Child } from 'pym.js';
    import Graphic from './Graphic.svelte';
    import pkg from '../package.json';
    import meta from './data/meta.json';
    import { onMount } from 'svelte';
    import manageParams from './utils/manageParams.js';
    
    let pymChild = $state();
    let width = $state(600);
    let height = $state(0);  
    let containerElement = $state();
    let manifestData = $state(null);
    let manifestDataEast = $state(null);

    const params = manageParams();
    
    const manifestUrl = 'https://ix-cnn-io-prod.s3.amazonaws.com/data/sst-anomaly-snapshots/20260518-pacific-west/manifest.json';
    const manifestUrlEast = 'https://ix-cnn-io-prod.s3.amazonaws.com/data/sst-anomaly-snapshots/20260518-pacific-east/manifest.json';

    const copy = { legend: 'Sea surface temperature anomaly (°F)' };
    
    function handlePymResize(newWidth) {
      width = newWidth;
    }
    
    function sendHeight() {
      if (pymChild) {
        pymChild.sendHeight();
      }
    }
    
    // Fetch manifest data
    fetch(manifestUrl)
      .then(response => response.json())
      .then(data => {
        manifestData = data;
        console.log('west manifest', manifestData);
      })
      .catch(error => {
        console.error('Error fetching west manifest:', error);
      });

    fetch(manifestUrlEast)
      .then(response => response.json())
      .then(data => {
        manifestDataEast = data;
        console.log('east manifest', manifestDataEast);
      })
      .catch(error => {
        console.error('Error fetching east manifest:', error);
      });
    
    // REACT TO HEIGHT CHANGES using $effect
    $effect(() => {
      if (pymChild && height > 0) {
        sendHeight();
      }
    });

    onMount(() => {
      pymChild = new Child({ 
        renderCallback: handlePymResize, 
        id: pkg.name 
      });

      // Add app class to meta container if app param is true
      if (params.app === 'true') {
        document.querySelector('#meta')?.classList.add('app');
      }
      
      document.querySelector('h1.headline').innerHTML = meta.headline;
      document.querySelector('h2.subhed').innerHTML = meta.subhed;

      if (containerElement) {
        const containerWidth = containerElement.clientWidth;
        if (containerWidth && containerWidth !== width) {
          width = containerWidth;
        }
      }
      
      return () => {
        if (pymChild) {
          pymChild.remove();
        }
      };
    });
  </script>
  
  <!-- BIND HEIGHT HERE -->
  <div bind:this={containerElement} bind:clientHeight={height} bind:clientWidth={width} class="app-container" class:app={params.app === 'true'}>
    <Graphic {width} {manifestData} {manifestDataEast} {copy} {params} />
  </div>
  
  <style>
    .app-container {
      width: 100%;
    }
  </style>
